import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // React.StrictMode intentionally omitted — in dev it double-invokes every effect,
  // which doubles every API call and makes navigation feel sluggish on this preview.
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
